<template>
    <div class="form-tool-bar">
        <div class="form-tool-wrapper">
            <div v-if="canEdit" class="edit-button-wrapper">
                <v-btn v-if="!editMode" class="mx-2 white--text" large :color="editMode ? 'white' : 'black'" @click="onEditClick" :depressed="editMode">
                    <v-icon dark>mdi-pencil</v-icon> ΕΠΕΞΕΡΓΑΣΙΑ
                </v-btn>
                <v-btn v-else class="mx-2 white--text" large color="red" @click="onCancelClick" :disabled="!editMode">
                    ΑΚΥΡΩΣΗ
                </v-btn>
            </div>
            <div v-if="(field && assignment[field]?.completedAt)" class="completed">
                <h4 class="completed-title">Ολοκληρώθηκε: </h4>
                <span class="completed-date">{{ getGreekDate(assignment[field]?.completedAt) }}</span>
            </div>
            <div v-else-if="!field && assignment.completedAt" class="completed">
                <h4 class="completed-title">Ολοκληρώση Ανάθεσης: </h4>
                <span class="completed-date">{{ getGreekDate(assignment.completedAt) }}</span>
            </div>
            <div v-if="!field" class="last-modified-wrapper">
                <v-chip
                    v-if="assignment.priority"
                    class="mr-2 white--text"
                    :color="priorities[assignment.priority]"
                    small
                >
                    <b>{{ assignment.priority }}</b>
                </v-chip>
                <v-chip
                    v-if="assignment.pilotImportType && assignment.type === 'PILOT'"
                    class="mr-2 white--text"
                    :color="assignment.pilotImportType === 'FROM_CONSTRUCTION' ? '#95b8d1' : '#b19cd9'"
                    small
                >
                    {{ getAssignmentImportTypeText(assignment) }}
                </v-chip>
                <info-assignment-button v-if="!field" :extraInfo="assignment.extraInfo" :size="40"/>
            </div>
            <div v-if="field && assignment[field]" class="last-modified-wrapper">
                <div class="form-info">
                    <div v-if="assignment[field].updatedAt">
                        <span class="last-modified-title">Τελ. Τροπ/ηση: </span>
                        <span class="last-modified-date">{{ getGreekDate(assignment[field].updatedAt) }}</span>
                    </div>
                    <div v-if="assignment[field].completedBy">
                        <span class="last-modified-title">Ολοκληρώθηκε από: </span>
                        <span class="last-modified-date">{{ assignment[field].completedBy.fullName }}</span>
                    </div>
                </div>
                <div v-if="containsAny(['ROLE_ADMIN'], userRoles) && assignment[field].geolocation && Object.keys(assignment[field].geolocation).length > 0">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" fab class="mx-2 white--text" x-small color="black" @click="openMaps(assignment[field].geolocation)">
                                <v-icon dark>mdi-google-maps</v-icon>
                            </v-btn>
                        </template>
                        <span>Ακρίβεια {{ parseInt(assignment[field].geolocation.accuracy) }}m</span>
                    </v-tooltip>
                </div>
            </div>
        </div>
        <div v-if="(this.assignment.address || this.assignment.sr)" class="assignment-info" :class="this.isStageCompleted ? 'assignment-info-completed' : 'assignment-info-not-completed'">
            <div v-if="this.assignment.sr" class="d-flex"><h4 class="mr-1">SR:</h4> {{ this.assignment.sr }}</div>
            <div v-if="this.assignment.address">{{ this.assignment.address }}
                <span v-if="this.assignment.location?.name">, {{ this.assignment.location.name }}</span>
            </div>
        </div>
    </div>
</template>
<script>
    import momentTimezone from 'moment-timezone'
    import InfoAssignmentButton from './InfoAssignmentButton'

    export default {
        components: { InfoAssignmentButton },
        computed: {
            config() {
                return this.$store.getters.getConfig || {}
            },
            pilotAssignmentImportTypes() {
                return this.config?.pilotImportTypes || []
            },
            isStageCompleted() {
                return !!this.assignment[this.$route.query.tab]?.completedAt || this.assignment[this.$route.query.tab]?.completed || ((!this.$route.query.tab || this.$route.query.tab === 'assignment') && this.assignment.completedAt)
            }
        },
        props: {
            userRoles: {
                type: Array,
                required: true
            },
            canEdit: {
                type: Boolean,
                required: true
            },
            editMode: {
                type: Boolean,
                required: true
            },
            assignment: {
                type: Object,
                required: true
            },
            field: {
                type: String,
                required: false
            }
        },
        data() {
            return {
                priorities: {
                    'A+': '#8b0000',
                    'A': '#ff0000',
                    'B': '#2596be',
                    'C': '#00b050'
                }
            }
        },
        methods: {
            getAssignmentImportTypeText(assignment) {
                if (assignment.type !== 'PILOT' || !assignment.pilotImportType) {
                    return null
                }
                return this.pilotAssignmentImportTypes.find(type => type.value === assignment.pilotImportType)?.name
            },
            getGreekDate(utcDate) {
                return momentTimezone(utcDate).utc().tz('Europe/Athens').format('YYYY-MM-DD HH:mm').toString()
            },
            onEditClick() {
                this.$emit('edit-button-clicked')
            },
            onCancelClick() {
                this.$emit('cancel-button-clicked')
            },
            containsAny(arr1, arr2) {
                return arr1.some(item => arr2.includes(item))
            },
            openMaps(geolocation) {
                window.open('https://www.google.gr/maps/place/' + geolocation.latitude + ',' + geolocation.longitude, '_blank').focus()
            }
        }
    }
</script>
<style scoped>
.form-info {
    display: flex;
    flex-direction: column;
}
.form-tool-wrapper {
    width: 100%;
    display: flex;
    padding: 1rem;
    padding-top: 0;
    flex-wrap: wrap;
    background: inherit !important;
    height: auto !important;
    justify-content: space-between;
    color: var(--cards-and-tables-text-color) !important;
}
.form-tool-bar {
    width: 100%;
    display: flex;
    flex-direction: column;
}
.assignment-info {
    width: 100%;
    display: flex;
    justify-content: space-around;
    border-radius: 5px 5px 0 0;
    box-shadow: 0px 4px 6px rgba(0,0,0,0.1);
    flex-wrap: wrap;
}

.assignment-info-not-completed {
    background: linear-gradient(to top, #FFFFFF, color-mix(in srgb, #FFFFFF 85%, black));
    color: black;
}

.assignment-info-completed {
    background: linear-gradient(to top, green, color-mix(in srgb, green 85%, black));
    color: white;
}

.last-modified-wrapper {
    display: flex;
    align-items: center;
}

.last-modified-date {
    font-size: 0.75rem;
    font-weight: 500;
}

.last-modified-title {
    font-size: 0.7rem;
}

.completed, .edit-button-wrapper, .last-modified-wrapper {
    width: 33%;
    min-width: 200px;
}
.completed-title {
    color: green;
}
.completed {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.last-modified-wrapper {
    display: flex;
    justify-content: flex-end;
}
@media only screen and (max-width: 505px) {
  .form-tool-bar {
        justify-content: center!important;
  }
  .completed, .edit-button-wrapper, .last-modified-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 0.5rem;
  }
}
</style>
